function isObject(value) {
    const type = typeof value;
    return value != null && (type === 'object' || type === 'function');
}
export function merge(object, source) {
    if (source === undefined) {
        return object;
    }
    if (source === null) {
        return null;
    }
    if (object === source) {
        return object;
    }
    if (typeof object !== typeof source) {
        if (source) {
            return source;
        }
        return object;
    }
    if (Array.isArray(object)) {
        const values = object.map((value, i) => merge(value, source[i]));
        if (source.length > object.length) {
            return [...values, source.slice(values.length - 1)];
        }
        return values;
    }
    if (isObject(object)) {
        const newObject = Object.entries(object).reduce((acc, [key, value]) => {
            if (source[key] !== undefined) {
                acc[key] = merge(value, source[key]);
            }
            else {
                acc[key] = value;
            }
            return acc;
        }, {});
        Object.entries(source).forEach(([key, value]) => {
            if (newObject[key] === undefined) {
                newObject[key] = value;
            }
        });
        return newObject;
    }
    return source;
}
